// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/suspension-systems/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const suspensionSystemsEN: PageEntry = {
  id: "post.federungssysteme",
  locale: "en",
  slug: "suspension-systems",
  seo: {
    title: "Glossary: Suspension systems explained simply | Dietz GmbH",
    description: "Suspension systems are mechanisms that use springs to absorb shocks and vibrations in vehicles or other mechanical systems. In vehicles, suspension systems are used to compensate f",
  },
  type: "post",
  h1: "Glossary: Suspension systems explained simply",
  intro: "Suspension systems are mechanisms that use springs to absorb shocks and vibrations in vehicles or other mechanical systems. In vehicles, suspension systems are used to compensate for bumps in the road and improve ride comfort. These systems often include shock absorbers in combination with different types of springs. The design of effective suspension systems requires a thorough understanding of the dynamic properties of springs and the specific requirements of the application.",
  blocks: [

  ],
};
